module.exports = __webpack_public_path__ + "static/media/knocked-out-face-svgrepo-com.23ddc819.svg";